import React from "react";
import {
    TICKET_BACKOFFICE_ROLES,
    IS_TICKET_EXTERNAL_ACCESS_BLOCKED,
    USER_TICKET_VIEWER_ROLES
} from "../constants/ticket";
import {APPLICATION_ROLES} from "../constants/application";
import {PAYMENTS_PERMISSION_KEYS} from "../constants/payments";
import {
    TeamOutlined,
    SettingOutlined,
    ShoppingOutlined,
    SendOutlined,
    BarChartOutlined,
    BuildOutlined,
    ClockCircleOutlined,
    FundOutlined,
    EnvironmentOutlined,
    LineChartOutlined,
    WalletOutlined,
    ShopOutlined,
    SafetyOutlined,
    RadarChartOutlined,
    ScheduleOutlined,
    CreditCardOutlined,
    ExclamationCircleOutlined,
    IssuesCloseOutlined,
    FireOutlined,
    TruckFilled,
    ToolFilled,
    FileTextOutlined,
    DollarCircleOutlined,
    HomeOutlined,
    AccountBookOutlined,
    TransactionOutlined,
    AlertOutlined,
    FileSearchOutlined,
    BankOutlined,
    FileDoneOutlined,
    CustomerServiceOutlined,
    SolutionOutlined,
    TagsOutlined
} from "@ant-design/icons";
import homeOutlinedIcon from "../public/images/home-outlined.svg";
import deliveryIcon from "../public/images/delivery-icon.svg";
import accountingIcon from "../public/images/accounting-icon.svg";
import createDeliveryIcon from "../public/images/create-delivery-icon.svg";
import courierIcon from "../public/images/courier-icon.svg";
import MapIcon from "../public/images/map-icon.svg";
import {CourierIcon} from "../components/_defaultComponents/CourierIcon/CourierIcon";
import {MetabaseLogoIcon} from "../components/_defaultComponents/MetabaseLogoIcon/MetabaseLogoIcon";
import i18n from "../i18n";
import meStore from "../store/meStore";
import {isDedicatedIntegrationCustomer} from "../utils/customerHelpers";
import config from "../_core/config";

// Metabase raporlarını görebilen roller (routes/index.js'teki AuthChecker ile ortak)
const metabaseAdminRoles = ["admin", "superadmin"];
const metabaseAllRoles = [
    ...metabaseAdminRoles,
    "bm",
    "sy",
    "ik",
    "agencyIk",
    "hr",
    "finance",
    "equipmentManager",
    "operationSupport"
];

// Dev ortamında Metabase prod datasını gösterdiği için rapor sadece admin'lere açıktır.
export const metabaseReportRoles = config.isDev ? metabaseAdminRoles : metabaseAllRoles;

export const routes = [
    {
        name: () => i18n.t("screens.liveMap", {ns: "common"}),
        icon: <EnvironmentOutlined />,
        path: "/map",
        selectedPath: "/map",
        navPosition: "top",
        "data-testid": "map",
        roles: [
            "admin",
            "superadmin",
            "cUser",
            "hr",
            "operationSupport",
            "oUser",
            "sOperation",
            "sChef",
            "data",
            "operationImproving",
            "software",
            "marketing"
        ]
    },
    {
        name: () => i18n.t("screens.liveOperation", {ns: "common"}),
        icon: <RadarChartOutlined />,
        path: "/anlik-operasyon",
        selectedPath: "/anlik-operasyon",
        navPosition: "top",
        "data-testid": "liveOperation",
        roles: ["admin", "superadmin", "bm", "sy", "agency"]
    },
    {
        name: () => i18n.t("screens.orders", {ns: "common"}),
        icon: <ShoppingOutlined />,
        path: "/orders",
        selectedPath: "/orders",
        navPosition: "top",
        "data-testid": "order",
        roles: [
            "admin",
            "superadmin",
            "cUser",
            "operationSupport",
            "oUser",
            "bm",
            "agency",
            "sy",
            "sOperation",
            "sChef",
            "data",
            "operationImproving",
            "software",
            "marketing",
            "seller",
            "sales"
        ]
    },
    // {
    //     name: () => "Transferler",
    //     icon: <TruckOutlined />,
    //     path: "/transfers",
    //     selectedPath: "/transfers",
    //     navPosition: "top",
    //     "data-testid": "order",
    //     roles: ["admin", "superadmin", "operationSupport", "oUser", "bm", "sy"],
    //     subMenus: [
    //         {
    //             name: () => "Dashboard",
    //             icon: <TruckOutlined />,
    //             subPath: "/dashboard",
    //             selectedPath: "/dashboard",
    //             navPosition: "top",
    //             roles: ["admin", "superadmin", "operationSupport", "oUser", "bm", "sy"]
    //         },
    //         {
    //             name: () => "Transfer Planlama",
    //             icon: <TruckOutlined />,
    //             subPath: "/transfers",
    //             selectedPath: "/transfers",
    //             navPosition: "top",
    //             roles: ["admin", "superadmin", "operationSupport", "oUser", "bm", "sy"]
    //         },
    //         {
    //             name: () => "Transfer Gruplama",
    //             icon: <UsergroupAddOutlined />,
    //             subPath: "/transfer-grouping",
    //             selectedPath: "/transfer-grouping",
    //             navPosition: "top",
    //             roles: ["admin", "superadmin", "operationSupport", "oUser", "bm", "sy"]
    //         },
    //         {
    //             name: () => "Aktif Transferler",
    //             icon: <UsergroupAddOutlined />,
    //             subPath: "/active-transfers",
    //             selectedPath: "/active-transfers",
    //             navPosition: "top",
    //             roles: ["admin", "superadmin", "operationSupport", "oUser", "bm", "sy"]
    //         },
    //         {
    //             name: () => "Transfer Aktiviteleri",
    //             icon: <UsergroupAddOutlined />,
    //             subPath: "/transfer-activities",
    //             selectedPath: "/transfer-activities",
    //             navPosition: "top",
    //             roles: ["admin", "superadmin", "operationSupport", "oUser", "bm", "sy"]
    //         },
    //         {
    //             name: () => "İade Talepleri",
    //             icon: <UsergroupAddOutlined />,
    //             subPath: "/undelivered-shipments",
    //             selectedPath: "/undelivered-shipments",
    //             navPosition: "top",
    //             roles: ["admin", "superadmin", "operationSupport", "oUser", "bm", "sy"]
    //         },
    //         {
    //             name: () => "Transfer Merkezleri",
    //             icon: <HomeOutlined />,
    //             subPath: "/transfer-center",
    //             selectedPath: "/transfer-center",
    //             navPosition: "top",
    //             roles: ["admin", "superadmin", "operationSupport", "oUser", "bm", "sy"]
    //         },
    //         {
    //             name: () => "Yeni Transfer Merkezi",
    //             icon: <PlusOutlined />,
    //             subPath: "/new-transfer-center",
    //             selectedPath: "/new-transfer-center",
    //             navPosition: "top",
    //             roles: ["admin", "superadmin", "operationSupport", "oUser", "bm", "sy"]
    //         }
    //     ]
    // },
    {
        name: () => "Sipariş Oluştur",
        icon: <SendOutlined />,
        path: "/create-delivery-request",
        selectedPath: "/create-delivery-request",
        navPosition: "top",
        "data-testid": "newRequest",
        roles: [
            "admin",
            "superadmin",
            "operationSupport",
            "software",
            "cUser",
            "oUser",
            "bm",
            "agency",
            "sy"
        ],
        subMenus: [
            {
                name: () => i18n.t("screens.newRequest", {ns: "common"}),
                icon: <SendOutlined />,
                path: "/third-party-request/new",
                selectedPath: "/third-party-request/new",
                navPosition: "top",
                "data-testid": "newRequest",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "software",
                    "cUser",
                    "oUser",
                    "bm",
                    "sy"
                ]
            },
            {
                name: () => `${i18n.t("screens.newRequest", {ns: "common"})} v2`,
                icon: <SendOutlined />,
                path: "/create-delivery-request",
                selectedPath: "/create-delivery-request",
                navPosition: "top",
                "data-testid": "createDeliveryRequest",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "software",
                    "cUser",
                    "oUser",
                    "bm",
                    "agency",
                    "sy"
                ]
            }
        ]
    },
    {
        name: () => "Kurye Yönetimi",
        // Görünür alt menü tek satıra düştüğünde (bkz. Theme.js) menü bu adla tekil link olur.
        collapsedName: () => "Kuryeler",
        icon: <CourierIcon />,
        path: "/couriers",
        selectedPath: "/couriers",
        navPosition: "top",
        "data-testid": "couriers",
        roles: [
            "admin",
            "superadmin",
            "finance",
            "hr",
            "hrEmployment",
            "equipmentManager",
            "ik",
            "agencyIk",
            "seller",
            "operationSupport",
            "oUser",
            "bm",
            "agency",
            "sy",
            "sOperation",
            "sChef",
            "data",
            "operationImproving",
            "software",
            "sales"
        ],
        subMenus: [
            {
                name: () => "Kuryeler",
                icon: <CourierIcon />,
                path: "/couriers",
                selectedPath: "/couriers",
                navPosition: "top",
                "data-testid": "couriers",
                roles: [
                    "admin",
                    "superadmin",
                    "finance",
                    "hr",
                    "hrEmployment",
                    "equipmentManager",
                    "ik",
                    "agencyIk",
                    "seller",
                    "operationSupport",
                    "oUser",
                    "bm",
                    "agency",
                    "sy",
                    "sOperation",
                    "sChef",
                    "data",
                    "operationImproving",
                    "software",
                    "sales"
                ]
            },
            {
                name: () => "Kurye Talepleri",
                icon: <CourierIcon courierType="motorCourier" />,
                path: "/couriers/courier-requests",
                selectedPath: "/couriers/courier-requests",
                navPosition: "top",
                "data-testid": "courier-requests",
                roles: ["admin", "superadmin", "bm", "sy", "ik", "agency", "agencyIk"]
            },
            {
                name: () => "Müsait Kuryeler",
                icon: <CourierIcon courierType="motorCourier" />,
                path: "/available-couriers",
                selectedPath: "/available-couriers",
                navPosition: "top",
                "data-testid": "available-couriers",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "oUser",
                    "bm",
                    "sy",
                    "sOperation",
                    "sChef"
                ]
            }
        ]
    },
    {
        name: () => "Firma Yönetimi",
        icon: <ShopOutlined />,
        path: "/",
        selectedPath: "/",
        navPosition: "top",
        "data-testid": "users",
        roles: [
            "admin",
            "superadmin",
            "finance",
            "data",
            "operationImproving",
            "software",
            "operationSupport",
            "oUser",
            "bm",
            "agency",
            "sy",
            "sOperation",
            "sChef",
            "seller",
            "sales"
        ],
        subMenus: [
            {
                name: () => i18n.t("screens.companies", {ns: "common"}),
                icon: <ShopOutlined />,
                subPath: "companies",
                selectedPath: "/companies",
                navPosition: "top",
                roles: [
                    "admin",
                    "superadmin",
                    "finance",
                    "data",
                    "operationImproving",
                    "software",
                    "operationSupport",
                    "oUser",
                    "bm",
                    "agency",
                    "sy",
                    "sOperation",
                    "sChef",
                    "seller",
                    "sales"
                ]
            },
            {
                name: () => "Alt Firmalar",
                icon: <ShopOutlined />,
                subPath: "subcompanies",
                selectedPath: "/subcompanies",
                navPosition: "top",
                roles: [
                    "admin",
                    "superadmin",
                    "finance",
                    "data",
                    "operationImproving",
                    "software",
                    "operationSupport",
                    "oUser",
                    "bm",
                    "agency",
                    "sy",
                    "sales"
                ]
            },
            {
                name: () => i18n.t("screens.integrators", {ns: "common"}),
                icon: <AccountBookOutlined />,
                path: "/integrators",
                selectedPath: "/integrators",
                navPosition: "top",
                "data-testid": "integrators",
                roles: ["oUser", "bm", "sy", "admin", "superadmin", "operationSupport", "software"]
            },
            {
                name: () => "Alt Firma Ücretlendirme",
                icon: <ShopOutlined />,
                subPath: "subcompanies/pricing-list",
                selectedPath: "/subcompanies/pricing-list",
                navPosition: "top",
                roles: ["admin", "superadmin", "sales", "agency"]
            }
        ]
    },
    {
        name: () => "Ekipman Yönetimi",
        icon: <TruckFilled />,
        path: "/equipments",
        selectedPath: "/equipments",
        navPosition: "top",
        "data-testid": "users",
        roles: [
            "admin",
            "superadmin",
            "data",
            "operationImproving",
            "software",
            "bm",
            "sy",
            "equipmentManager",
            "ik"
        ],
        subMenus: [
            {
                name: () => "Ekipman Talepleri",
                icon: <FileTextOutlined />,
                subPath: "/requests",
                selectedPath: "/requests",
                navPosition: "top",
                roles: ["admin", "superadmin", "bm", "equipmentManager", "sy"]
            },
            {
                name: () => "Ekipmanlar",
                icon: <ToolFilled />,
                subPath: "/",
                selectedPath: "",
                navPosition: "top",
                roles: [
                    "admin",
                    "superadmin",
                    "data",
                    "operationImproving",
                    "software",
                    "equipmentManager"
                ]
            },
            {
                name: () => "Kurye Ekipman Yönetimi",
                icon: <TruckFilled />,
                subPath: "/courier-equipments",
                selectedPath: "/courier-equipments",
                navPosition: "top",
                roles: [
                    "admin",
                    "superadmin",
                    "data",
                    "operationImproving",
                    "software",
                    "equipmentManager",
                    "bm",
                    "sy",
                    "ik"
                ]
            },
            {
                name: () => "Ekipman Tipleri",
                icon: <SettingOutlined />,
                subPath: "/types",
                selectedPath: "/types",
                navPosition: "top",
                roles: [
                    "admin",
                    "superadmin",
                    "data",
                    "operationImproving",
                    "software",
                    "equipmentManager"
                ]
            }
        ]
    },
    {
        name: () => "Vardiya Yönetimi",
        icon: <ClockCircleOutlined />,
        path: "/shift-management",
        selectedPath: "/shift-management",
        navPosition: "top",
        "data-testid": "shift-management",
        roles: [
            "admin",
            "superadmin",
            "operationSupport",
            "software",
            "oUser",
            "bm",
            "agency",
            "sy",
            "sOperation",
            "sChef",
            "seller"
        ]
        // subMenus: [
        //     // {
        //     //     name: () => i18n.t("screens.shiftManagement", {ns: "common"}),
        //     //     icon: <ClockCircleOutlined />,
        //     //     path: "/shift-management",
        //     //     selectedPath: "/shift-management",
        //     //     navPosition: "top",
        //     //     "data-testid": "shift-management",
        //     //     roles: [
        //     //         "admin",
        //     //         "superadmin",
        //     //         "operationSupport",
        //     //         "software",
        //     //         "oUser",
        //     //         "bm",
        //     //         "agency",
        //     //         "sy",
        //     //         "sOperation",
        //     //         "sChef",
        //     //         "seller"
        //     //     ]
        //     // }
        //     // {
        //     //     name: () => i18n.t("screens.courierSupportRequests", {ns: "common"}),
        //     //     icon: <ScheduleOutlined />,
        //     //     path: "/shift-requests",
        //     //     selectedPath: "/shift-requests",
        //     //     navPosition: "top",
        //     //     "data-testid": "courierSupportRequests",
        //     //     roles: [
        //     //         "admin",
        //     //         "superadmin",
        //     //         "software",
        //     //         "bm",
        //     //         "agency",
        //     //         "sy",
        //     //         "sales",
        //     //         "hr",
        //     //         "ik"
        //     //     ]
        //     // },
        // ]
    },
    {
        name: () => "Havuz Yönetimi",
        icon: <RadarChartOutlined />,
        path: "/pools",
        selectedPath: "/pools",
        navPosition: "top",
        "data-testid": "pools",
        roles: [
            "admin",
            "superadmin",
            "operationSupport",
            "oUser",
            "bm",
            "agency",
            "sy",
            "sOperation",
            "sChef"
        ],
        subMenus: [
            {
                name: () => i18n.t("screens.poolRegionManagement", {ns: "common"}),
                icon: <RadarChartOutlined />,
                subPath: "/",
                selectedPath: "",
                navPosition: "top",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "oUser",
                    "bm",
                    "agency",
                    "sy",
                    "sOperation",
                    "sChef"
                ]
            },
            {
                name: () => i18n.t("screens.poolShiftManagement", {ns: "common"}),
                icon: <ClockCircleOutlined />,
                subPath: "/shift-management",
                selectedPath: "/shift-management",
                navPosition: "top",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "oUser",
                    "bm",
                    "sy",
                    "sOperation",
                    "sChef"
                ]
            },
            {
                name: () => i18n.t("screens.poolIntensities", {ns: "common"}),
                icon: <FireOutlined />,
                subPath: "/intensities",
                selectedPath: "/intensities",
                navPosition: "top",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "oUser",
                    "bm",
                    "agency",
                    "sy",
                    "sOperation",
                    "sChef"
                ]
            },
            {
                name: () => i18n.t("screens.poolIntensityCallbacks", {ns: "common"}),
                icon: <AlertOutlined />,
                subPath: "/intensity/callbacks",
                selectedPath: "/intensity/callbacks",
                navPosition: "top",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "oUser",
                    "bm",
                    "sy",
                    "sOperation",
                    "sChef"
                ]
            },
            {
                name: () =>
                    meStore.checkRole("isAgency")
                        ? i18n.t("screens.poolIntegratedShifts", {ns: "common"})
                        : i18n.t("screens.poolDailyShifts", {ns: "common"}),
                icon: <ScheduleOutlined />,
                subPath: "/courier-shifts",
                selectedPath: "/courier-shifts",
                navPosition: "top",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "oUser",
                    "bm",
                    "agency",
                    "sy",
                    "sOperation"
                ]
            },
            {
                name: () => i18n.t("screens.poolShiftCancelRequests", {ns: "common"}),
                icon: <IssuesCloseOutlined />,
                subPath: "/shift-cancel-requests",
                selectedPath: "/shift-cancel-requests",
                navPosition: "top",
                roles: ["admin", "superadmin", "operationSupport", "oUser", "bm", "sy"]
            }
        ]
    },
    {
        name: () => i18n.t("screens.users", {ns: "common"}),
        icon: <TeamOutlined />,
        path: "/users",
        selectedPath: "/users",
        navPosition: "top",
        "data-testid": "users",
        roles: [
            "admin",
            "superadmin",
            "data",
            "operationImproving",
            "software",
            "agency",
            ...USER_TICKET_VIEWER_ROLES
        ],
        subMenus: [
            {
                name: () => i18n.t("screens.users", {ns: "common"}),
                icon: <TeamOutlined />,
                subPath: "/",
                selectedPath: "",
                navPosition: "top",
                roles: [
                    "admin",
                    "superadmin",
                    "data",
                    "operationImproving",
                    "software",
                    "agency",
                    ...USER_TICKET_VIEWER_ROLES
                ]
            },
            {
                name: () => i18n.t("screens.authorizationManagement", {ns: "common"}),
                icon: <SafetyOutlined />,
                subPath: "/authorization-management",
                selectedPath: "/authorization-management",
                navPosition: "top",
                roles: ["admin", "superadmin", "data", "operationImproving", "software"]
            },
            {
                name: () => "Operasyon Organizasyonu",
                icon: <BuildOutlined />,
                subPath: "/operation-organization",
                selectedPath: "/operation-organization",
                navPosition: "top",
                roles: ["admin", "superadmin", "data", "operationImproving", "software"]
            }
        ]
    },
    {
        name: () => i18n.t("menu.ticketManagement", {ns: "tickets"}),
        icon: <CustomerServiceOutlined />,
        path: "/ticket-management",
        selectedPath: "/ticket-management",
        navPosition: "top",
        "data-testid": "ticket-management",
        roles: TICKET_BACKOFFICE_ROLES,
        subMenus: [
            {
                name: () => i18n.t("menu.ticketList", {ns: "tickets"}),
                icon: <CustomerServiceOutlined />,
                path: "/ticket-management",
                selectedPath: "/ticket-management",
                navPosition: "top",
                "data-testid": "ticket-list",
                roles: TICKET_BACKOFFICE_ROLES
            },
            {
                name: () => i18n.t("menu.ticketTypes", {ns: "tickets"}),
                icon: <TagsOutlined />,
                path: "/ticket-types",
                selectedPath: "/ticket-types",
                navPosition: "top",
                "data-testid": "ticket-types",
                roles: ["admin", "superadmin", "software"]
            }
        ]
    },
    {
        name: () => i18n.t("menu.applications", {ns: "applications"}),
        icon: <SolutionOutlined />,
        path: "/applications",
        selectedPath: "/applications",
        navPosition: "top",
        "data-testid": "applications",
        roles: APPLICATION_ROLES
    },
    {
        name: () => "Muhasebe ve Finans",
        icon: <DollarCircleOutlined />,
        path: "/payment-finance",
        selectedPath: "/payment-finance",
        navPosition: "top",
        "data-testid": "payment-finance",
        roles: [
            "admin",
            "superadmin",
            "operationSupport",
            "software",
            "cUser",
            "finance",
            "oUser",
            "bm",
            "agency",
            "sy",
            "equipmentManager"
        ],
        subMenus: [
            {
                name: () => "Cari Detaylar",
                icon: <FileSearchOutlined />,
                path: "/credit-logs/cari-list/all",
                selectedPath: "/credit-logs/cari-list/all",
                navPosition: "top",
                "data-testid": "cari-list-all",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "software",
                    "oUser",
                    "bm",
                    "sy",
                    "finance"
                ]
            },
            {
                name: () => "Cari Hesaplar",
                icon: <BankOutlined />,
                path: "/credit-logs/cari-list",
                selectedPath: "/credit-logs/cari-list",
                navPosition: "top",
                "data-testid": "cari-list",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "software",
                    "oUser",
                    "bm",
                    "sy",
                    "finance"
                ]
            },
            {
                name: () => "Kredi Hareketleri",
                icon: <CreditCardOutlined />,
                path: "/credit-logs",
                selectedPath: "/credit-logs",
                navPosition: "top",
                "data-testid": "creditLogs",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "software",
                    "bm",
                    "agency",
                    "sy",
                    "finance",
                    "equipmentManager"
                ]
            },
            {
                name: () => "Carili Firma Faturaları",
                icon: <FileDoneOutlined />,
                path: "/subcompany-invoices",
                selectedPath: "/subcompany-invoices",
                navPosition: "top",
                "data-testid": "subCompanyInvoices",
                roles: ["admin", "finance"]
            },
            {
                name: () => "Paket İtirazları",
                icon: <ExclamationCircleOutlined />,
                path: "/packet-objection",
                selectedPath: "/packet-objection",
                navPosition: "top",
                "data-testid": "packetObjection",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "software",
                    "cUser",
                    "oUser",
                    "bm",
                    "agency",
                    "sy"
                ]
            },
            {
                name: () => "Eklenti & Kesinti Yönetimi",
                icon: <TransactionOutlined />,
                path: "/adjustments",
                selectedPath: "/adjustments",
                navPosition: "top",
                "data-testid": "adjustments",
                roles: ["admin", "superadmin", "finance"],
                isHeader: true
            },
            {
                name: () => "Eklenti & Kesinti Tipleri",
                path: "/adjustments/adjustment-types",
                selectedPath: "/adjustments/adjustment-types",
                navPosition: "top",
                "data-testid": "adjustment-types",
                roles: ["admin", "superadmin", "finance", "equipmentManager"],
                isSmallFont: true
            },
            {
                name: () => "Kurye Eklentiler & Kesintiler",
                path: "/adjustments/courier-adjustments",
                selectedPath: "/adjustments/courier-adjustments",
                navPosition: "top",
                "data-testid": "courier-adjustments",
                roles: ["admin", "superadmin", "finance", "equipmentManager"],
                isSmallFont: true
            }
        ]
    },
    {
        name: () => "Ödemeler",
        icon: <WalletOutlined />,
        path: "/payments",
        selectedPath: "/payments",
        navPosition: "top",
        "data-testid": "payments",
        roles: [
            "admin",
            "superadmin",
            "operationSupport",
            "software",
            "cUser",
            "finance",
            "oUser",
            "bm",
            "agency",
            "sy",
            "equipmentManager"
        ],
        permissionKeys: [PAYMENTS_PERMISSION_KEYS.viewPage],
        bold: true,
        subMenus: [
            {
                name: () => "Ödemeler",
                icon: <WalletOutlined />,
                path: "/payments",
                selectedPath: "/payments",
                navPosition: "top",
                "data-testid": "payments",
                roles: ["admin", "superadmin", "finance", "bm", "agency", "operationSupport"],
                permissionKeys: [PAYMENTS_PERMISSION_KEYS.viewPage]
            },
            {
                name: () => "Kapıda Ödeme Yönetimi",
                icon: <DollarCircleOutlined />,
                path: "/payment-finance",
                selectedPath: "/payment-finance",
                navPosition: "top",
                "data-testid": "cash-on-delivery",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "oUser",
                    "bm",
                    "agency",
                    "sy",
                    "finance"
                ],
                isHeader: true
            },
            {
                name: () => "Kapıda Ödeme",
                path: "/cash-on-delivery",
                selectedPath: "/cash-on-delivery",
                navPosition: "top",
                "data-testid": "cash-on-delivery",
                roles: ["admin", "superadmin", "operationSupport", "oUser", "bm", "sy", "finance"],
                isSmallFont: true
            },
            {
                name: () => "Kurye - Terminal Listesi",
                path: "/cash-on-delivery/courier-terminals",
                selectedPath: "/cash-on-delivery/courier-terminals",
                navPosition: "top",
                "data-testid": "courier-terminals",
                roles: ["admin", "superadmin", "operationSupport", "oUser", "bm", "sy", "finance"],
                isSmallFont: true
            },
            {
                // Acentede sekme yalnızca acentenin kullandığı kapıda ödeme alt firmalarını
                // listelediği için "Kapıda Ödeme Kullanan Alt Firmalar" olarak adlandırılır.
                name: () =>
                    meStore.checkRole("isAgency")
                        ? "Kapıda Ödeme Kullanan Alt Firmalar"
                        : "Alt Firmalar",
                path: "/cash-on-delivery/subCompanies",
                selectedPath: "/cash-on-delivery/subCompanies",
                navPosition: "top",
                "data-testid": "past-periods",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "oUser",
                    "bm",
                    "agency",
                    "sy",
                    "finance"
                ],
                isSmallFont: true
            },
            {
                name: () => "Geçmiş Dönemler",
                path: "/cash-on-delivery/past-periods",
                selectedPath: "/cash-on-delivery/past-periods",
                navPosition: "top",
                "data-testid": "past-periods",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "oUser",
                    "bm",
                    "agency",
                    "sy",
                    "finance"
                ],
                isSmallFont: true
            },
            {
                name: () => "Özet",
                path: "/cash-on-delivery/cash-on-delivery-summary",
                selectedPath: "/cash-on-delivery/cash-on-delivery-summary",
                navPosition: "top",
                "data-testid": "cash-on-delivery-summary",
                roles: ["admin", "superadmin", "operationSupport", "oUser", "bm", "sy", "finance"],
                isSmallFont: true
            },
            {
                name: () => "Cüzdan",
                icon: <WalletOutlined />,
                path: "/wallet",
                selectedPath: "/wallet",
                navPosition: "top",
                "data-testid": "wallet",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "oUser",
                    "bm",
                    "agency",
                    "sy",
                    "finance"
                ],
                isHeader: true
            },
            {
                name: () => "Kurye Cüzdanları",
                path: "/wallet/couriers",
                selectedPath: "/wallet/couriers",
                navPosition: "top",
                "data-testid": "couriers",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "oUser",
                    "bm",
                    "agency",
                    "sy",
                    "finance",
                    "equipmentManager"
                ],
                isSmallFont: true
            },
            {
                name: () => "İnaktif Kurye Cüzdanları",
                path: "/wallet/inactive-couriers",
                selectedPath: "/wallet/inactive-couriers",
                navPosition: "top",
                "data-testid": "inactive-couriers",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "oUser",
                    "bm",
                    "agency",
                    "sy",
                    "finance",
                    "equipmentManager"
                ],
                isSmallFont: true
            },
            {
                name: () => "Eklenti & Kesinti",
                path: "/wallet/courier-financial-uploads",
                selectedPath: "/wallet/courier-financial-uploads",
                navPosition: "top",
                "data-testid": "wallet-courier-financial-uploads",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "software",
                    "bm",
                    "sy",
                    "finance",
                    "equipmentManager"
                ],
                isSmallFont: true
            }
        ]
    },
    {
        name: () => "Genel Raporlar",
        icon: <BarChartOutlined />,
        suffixIcon: <MetabaseLogoIcon />,
        suffixIconRoles: metabaseReportRoles,
        path: "/reports",
        selectedPath: "/reports",
        navPosition: "top",
        "data-testid": "reports",
        roles: [
            "admin",
            "superadmin",
            "cUser",
            "oUser",
            "bm",
            "agency",
            "sy",
            "ik",
            "agencyIk",
            "equipmentManager",
            "sChef",
            "sOperation",
            "operationSupport",
            "software",
            "finance",
            "hr"
        ],
        subMenus: [
            {
                name: () => i18n.t("screens.generalReports", {ns: "common"}),
                icon: <BarChartOutlined />,
                subPath: "/",
                selectedPath: "",
                navPosition: "top",
                "data-testid": "reports",
                roles: [
                    "admin",
                    "superadmin",
                    "cUser",
                    "oUser",
                    "bm",
                    "agency",
                    "sy",
                    "ik",
                    "agencyIk",
                    "equipmentManager",
                    "finance",
                    "hr"
                ]
            },
            {
                name: () => i18n.t("screens.orderStatisticsReport", {ns: "common"}),
                icon: <BarChartOutlined />,
                subPath: "/order",
                selectedPath: "/order",
                navPosition: "top",
                "data-testid": "reports-orderStatistics",
                roles: ["admin", "superadmin", "cUser", "oUser", "bm", "sy"]
            },
            {
                name: () => i18n.t("screens.courierStatisticsReport", {ns: "common"}),
                icon: <BarChartOutlined />,
                subPath: "/courierStatistics",
                selectedPath: "/courierStatistics",
                navPosition: "top",
                "data-testid": "reports-courierStatistics",
                roles: ["admin", "superadmin", "cUser", "oUser", "bm", "sy"]
            },
            {
                name: () => i18n.t("screens.shiftComplianceReport", {ns: "common"}),
                icon: <BarChartOutlined />,
                subPath: "/shift-compliance",
                selectedPath: "/shift-compliance",
                navPosition: "top",
                "data-testid": "reports-shiftCompliance",
                roles: ["admin", "superadmin", "oUser", "bm", "agency", "sy", "sChef"]
            },
            {
                name: () => i18n.t("screens.statistics", {ns: "common"}),
                icon: <FundOutlined />,
                path: "/statistics",
                selectedPath: "/statistics",
                navPosition: "top",
                "data-testid": "statistics",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "software",
                    "cUser",
                    "oUser",
                    "bm",
                    "sy",
                    "sOperation",
                    "sChef"
                ]
            },
            {
                name: () => "Raporlar (Metabase)",
                icon: <MetabaseLogoIcon />,
                badge: "YENİ",
                path: "/reports/metabase",
                selectedPath: "/reports/metabase",
                navPosition: "top",
                "data-testid": "reports-metabase",
                roles: metabaseReportRoles,
                isHeader: true
            },
            {
                name: () => "Kuryeler",
                path: "/reports/metabase/couriers",
                selectedPath: "/reports/metabase/couriers",
                navPosition: "top",
                "data-testid": "reports-metabase-couriers",
                roles: metabaseReportRoles,
                isSmallFont: true
            }
        ]
    },
    // {
    //     name: () => `${i18n.t("screens.shiftRequest", {ns: "common"})}`,
    //     icon: <ScheduleOutlined />,
    //     path: "/shift-request",
    //     selectedPath: "/shift-request",
    //     navPosition: "top",
    //     "data-testid": "shiftRequest",
    //     roles: [
    //         "admin",
    //         "superadmin",
    //         "operationSupport",
    //         "software",
    //         "cUser",
    //         "oUser",
    //         "bm",
    //         "sy"
    //     ],
    //     subMenus: [
    //         {
    //             name: () => `${i18n.t("screens.shiftRequest", {ns: "common"})}`,
    //             icon: <ScheduleOutlined />,
    //             subPath: "/",
    //             selectedPath: "",
    //             navPosition: "top",
    //             "data-testid": "shiftRequest",
    //             roles: [
    //                 "admin",
    //                 "superadmin",
    //                 "operationSupport",
    //                 "software",
    //                 "cUser",
    //                 "oUser",
    //                 "bm",
    //                 "sy"
    //             ]
    //         },
    //         {
    //             name: () => `${i18n.t("screens.shiftRequestManagement", {ns: "common"})}`,
    //             icon: <ScheduleOutlined />,
    //             subPath: "/management",
    //             selectedPath: "/management",
    //             navPosition: "top",
    //             "data-testid": "shiftRequestManagement",
    //             roles: ["admin", "superadmin", "operationSupport", "software", "oUser", "bm", "sy"]
    //         }
    //     ]
    // },
    // {
    //     name: () => i18n.t("screens.heatMap", {ns: "common"}),
    //     icon: <HeatMapOutlined />,
    //     path: "/heatmap",
    //     selectedPath: "/heatmap",
    //     navPosition: "top",
    //     "data-testid": "heatMap",
    //     roles: ["admin", "superadmin", "operationSupport", "software"]
    // },

    // {
    //     name: () => i18n.t("screens.shiftSuggestion", {ns: "common"}),
    //     icon: <PushpinOutlined />,
    //     path: "/shift-suggestion",
    //     selectedPath: "/shift-suggestion",
    //     navPosition: "top",
    //     "data-testid": "shiftSuggestion",
    //     roles: [
    //         "admin",
    //         "superadmin",
    //         "operationSupport",
    //         "software",
    //         "oUser",
    //         "bm",
    //         "sy",
    //         "sOperation"
    //     ]
    // },
    {
        name: () => "Hakediş Yönetimi",
        //name: () => i18n.t("screens.shiftSuggestion", {ns: "common"}),
        icon: <WalletOutlined />,
        path: "/payment-management",
        selectedPath: "/payment-management",
        navPosition: "top",
        "data-testid": "paymentManagement",
        roles: ["admin", "superadmin", "finance"]
    },
    {
        name: () => "Sözleşme Şablon Yönetimi",
        icon: <FileTextOutlined />,
        path: "/contract-management",
        selectedPath: "/contract-management",
        navPosition: "top",
        "data-testid": "contract",
        roles: ["admin", "superadmin", "operationSupport"]
    },
    {
        name: () => i18n.t("screens.appConfig", {ns: "common"}),
        icon: <SettingOutlined />,
        path: "/appconfig",
        selectedPath: "/appconfig",
        navPosition: "bottom",
        "data-testid": "appconfig",
        roles: ["superadmin"]
    }
];

export const customerRoutes = [
    {
        name: () => i18n.t("screens.shiftScoreList", {ns: "common"}),
        icon: <ClockCircleOutlined />,
        path: "/reports/shift-score",
        selectedPath: "/reports/shift-score",
        navPosition: "top",
        "data-testid": "reports-shiftScore",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.myOrders", {ns: "common"}),
        icon: <ShoppingOutlined />,
        path: "/orders",
        selectedPath: "/orders",
        navPosition: "top",
        "data-testid": "order",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.liveMap", {ns: "common"}),
        icon: <EnvironmentOutlined />,
        path: "/map",
        selectedPath: "/map",
        navPosition: "top",
        "data-testid": "map",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.packageStatistics", {ns: "common"}),
        icon: <FundOutlined />,
        path: "/statistics",
        selectedPath: "/statistics",
        navPosition: "top",
        "data-testid": "statistics",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.orderStatisticsReport", {ns: "common"}),
        icon: <BarChartOutlined />,
        path: "/reports/order",
        selectedPath: "/reports/order",
        navPosition: "top",
        "data-testid": "reports-orderStatistics",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.courierStatisticsReport", {ns: "common"}),
        icon: <BarChartOutlined />,
        path: "/reports/courierStatistics",
        selectedPath: "/reports/courierStatistics",
        navPosition: "top",
        "data-testid": "reports-courierStatistics",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.generalReports", {ns: "common"}),
        icon: <LineChartOutlined />,
        path: "/reports",
        selectedPath: "/reports",
        navPosition: "top",
        "data-testid": "reports",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/create-delivery-request",
        selectedPath: "/create-delivery-request",
        navPosition: "top",
        "data-testid": "createDeliveryRequest",
        roles: [
            "admin",
            "superadmin",
            "operationSupport",
            "software",
            "cUser",
            "oUser",
            "bm",
            "agency",
            "sy"
        ]
    },
    {
        name: () => `${i18n.t("screens.creditLogs", {ns: "common"})}`,
        icon: <CreditCardOutlined />,
        path: "/credit-logs",
        selectedPath: "/credit-logs",
        navPosition: "top",
        "data-testid": "creditLogs",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser"]
    },
    {
        name: () => i18n.t("screens.payments", {ns: "common"}),
        icon: <WalletOutlined />,
        path: "/payments",
        selectedPath: "/payments",
        navPosition: "top",
        "data-testid": "map",
        roles: ["cUser"]
    }
];

export const dedicatedCustomerRoutes = [
    {
        name: () => i18n.t("screens.home", {ns: "common"}),
        icon: <HomeOutlined />,
        path: "/musteri",
        selectedPath: "/musteri",
        navPosition: "top",
        "data-testid": "customer-shift-score",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.liveMap", {ns: "common"}),
        icon: <EnvironmentOutlined />,
        path: "/musteri/harita",
        selectedPath: "/musteri/harita",
        navPosition: "top",
        "data-testid": "map",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.packageStatistics", {ns: "common"}),
        icon: <FundOutlined />,
        path: "/musteri/istatistikler",
        selectedPath: "/musteri/istatistikler",
        navPosition: "top",
        "data-testid": "statistics",
        roles: ["cUser"]
    }
];

export const nonApiIntegratedCustomerRoutes = [
    {
        name: () => i18n.t("screens.home", {ns: "common"}),
        icon: <HomeOutlined />,
        path: "/musteri/vardiya-puantaj",
        selectedPath: "/musteri/vardiya-puantaj",
        navPosition: "top",
        "data-testid": "customer-shift-score",
        roles: ["cUser"]
    },
    // {
    //     name: () => i18n.t("screens.shiftScoreList", {ns: "common"}),
    //     icon: <ClockCircleOutlined />,
    //     path: "/reports/shift-score",
    //     selectedPath: "/reports/shift-score",
    //     navPosition: "top",
    //     "data-testid": "reports-shiftScore",
    //     roles: ["cUser"]
    // },
    {
        name: () => i18n.t("screens.liveMap", {ns: "common"}),
        icon: <EnvironmentOutlined />,
        path: "/map",
        selectedPath: "/map",
        navPosition: "top",
        "data-testid": "map",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.companyOnboarding", {ns: "common"}),
        icon: <ShopOutlined />,
        path: "/onboardingCompany",
        selectedPath: "/onboardingCompany",
        navPosition: "top",
        "data-testid": "map",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.payments", {ns: "common"}),
        icon: <WalletOutlined />,
        path: "/payments",
        selectedPath: "/payments",
        navPosition: "top",
        "data-testid": "map",
        roles: ["cUser"]
    }
];

export const poolCustomerRoutes = [
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/create-delivery-request",
        selectedPath: "/create-delivery-request",
        navPosition: "top",
        "data-testid": "createDeliveryRequest",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser"]
    },
    {
        name: () => i18n.t("screens.statistics", {ns: "common"}),
        icon: <FundOutlined />,
        path: "/statistics",
        selectedPath: "/statistics",
        navPosition: "top",
        "data-testid": "statistics",
        roles: [
            "admin",
            "superadmin",
            "operationSupport",
            "software",
            "cUser",
            "oUser",
            "bm",
            "agency",
            "sy"
        ]
    },
    {
        name: () => i18n.t("screens.myOrders", {ns: "common"}),
        icon: <ShoppingOutlined />,
        path: "/orders",
        selectedPath: "/orders",
        navPosition: "top",
        "data-testid": "order",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.creditLogs", {ns: "common"})}`,
        icon: <CreditCardOutlined />,
        path: "/credit-logs",
        selectedPath: "/credit-logs",
        navPosition: "top",
        "data-testid": "creditLogs",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser"]
    }
];

export const poolAndUatCustomerRoutes = [
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/musteri",
        selectedPath: "/musteri",
        navPosition: "top",
        "data-testid": "customerHomePage",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/musteri/siparislerim",
        selectedPath: "/musteri/siparislerim",
        navPosition: "top",
        "data-testid": "customer",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/musteri/muhasebe",
        selectedPath: "/musteri/muhasebe",
        navPosition: "top",
        "data-testid": "customer",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/musteri/manuel-gonderi-olustur",
        selectedPath: "/musteri/manuel-gonderi-olustur",
        navPosition: "top",
        "data-testid": "customer",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/musteri/duyurular",
        selectedPath: "/musteri/duyurular",
        navPosition: "top",
        "data-testid": "customer",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/musteri/hesabim",
        selectedPath: "/musteri/hesabim",
        navPosition: "top",
        "data-testid": "customer",
        roles: ["cUser"]
    },
    {
        name: () => "Kapıda Ödeme", //Müşteri
        icon: <DollarCircleOutlined />,
        path: "/musteri/kapida-odeme",
        selectedPath: "/musteri/kapida-odeme",
        navPosition: "top",
        "data-testid": "cashOnDelivery",
        roles: ["cUser"]
    },
    {
        name: () => "Kapıda Ödemeler - Geçmiş Dönemler", //Müşteri
        icon: <DollarCircleOutlined />,
        path: "/musteri/kapida-odeme/gecmis-donemler",
        selectedPath: "/musteri/kapida-odeme/gecmis-donemler",
        navPosition: "top",
        "data-testid": "cashOnDelivery",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/create-delivery-request",
        selectedPath: "/create-delivery-request",
        navPosition: "top",
        "data-testid": "createDeliveryRequest",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser"]
    },
    {
        name: () => i18n.t("screens.statistics", {ns: "common"}),
        icon: <FundOutlined />,
        path: "/statistics",
        selectedPath: "/statistics",
        navPosition: "top",
        "data-testid": "statistics",
        roles: [
            "admin",
            "superadmin",
            "operationSupport",
            "software",
            "cUser",
            "oUser",
            "bm",
            "agency",
            "sy"
        ]
    },
    {
        name: () => i18n.t("screens.myOrders", {ns: "common"}),
        icon: <ShoppingOutlined />,
        path: "/orders",
        selectedPath: "/orders",
        navPosition: "top",
        "data-testid": "order",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.creditLogs", {ns: "common"})}`,
        icon: <CreditCardOutlined />,
        path: "/credit-logs",
        selectedPath: "/credit-logs",
        navPosition: "top",
        "data-testid": "creditLogs",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/create-delivery-request",
        selectedPath: "/create-delivery-request",
        navPosition: "top",
        "data-testid": "createDeliveryRequest",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser"]
    },
    {
        name: () => i18n.t("screens.statistics", {ns: "common"}),
        icon: <FundOutlined />,
        path: "/statistics",
        selectedPath: "/statistics",
        navPosition: "top",
        "data-testid": "statistics",
        roles: [
            "admin",
            "superadmin",
            "operationSupport",
            "software",
            "cUser",
            "oUser",
            "bm",
            "agency",
            "sy"
        ]
    },
    {
        name: () => i18n.t("screens.myOrders", {ns: "common"}),
        icon: <ShoppingOutlined />,
        path: "/orders",
        selectedPath: "/orders",
        navPosition: "top",
        "data-testid": "order",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.creditLogs", {ns: "common"})}`,
        icon: <CreditCardOutlined />,
        path: "/credit-logs",
        selectedPath: "/credit-logs",
        navPosition: "top",
        "data-testid": "creditLogs",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser", "equipmentManager"]
    }
];

export const getDedicatedCustomerMenuItems = (history, setIsMobileMenuOpen) => {
    return [
        {
            title: "Anasayfa",
            icon: homeOutlinedIcon,
            path: "/musteri",
            onClick: () => {
                history.push("/musteri");
                setIsMobileMenuOpen(false);
            }
        },
        {
            title: "Canlı Harita",
            icon: MapIcon,
            path: "/musteri/harita",
            onClick: () => {
                history.push("/musteri/harita");
                setIsMobileMenuOpen(false);
            }
        },
        {
            title: i18n.t("screens.generalReports", {ns: "common"}),
            icon: accountingIcon,
            path: "/musteri/raporlar",
            selectedPath: "/musteri/raporlar",
            onClick: () => {
                history.push("/musteri/raporlar");
                setIsMobileMenuOpen(false);
            }
        },
        {
            title: i18n.t("screens.requests", {ns: "common"}),
            icon: accountingIcon,
            path: "/musteri/taleplerim",
            selectedPath: "/musteri/taleplerim",
            onClick: () => {
                history.push("/musteri/taleplerim");
                setIsMobileMenuOpen(false);
            }
        },
        ...(IS_TICKET_EXTERNAL_ACCESS_BLOCKED
            ? []
            : [
                  {
                      title: i18n.t("menu.ticketManagement", {ns: "tickets"}),
                      icon: accountingIcon,
                      path: "/musteri/talep-yonetimi",
                      selectedPath: "/musteri/talep-yonetimi",
                      onClick: () => {
                          history.push("/musteri/talep-yonetimi");
                          setIsMobileMenuOpen(false);
                      }
                  }
              ]),
        {
            title: i18n.t("screens.newRequest", {ns: "common"}),
            icon: createDeliveryIcon,
            path: "/musteri/manuel-gonderi-olustur",
            selectedPath: "/musteri/manuel-gonderi-olustur",
            onClick: () => {
                history.push("/musteri/manuel-gonderi-olustur");
                setIsMobileMenuOpen(false);
            }
        },
        {
            title: i18n.t("screens.myOrders", {ns: "common"}),
            icon: deliveryIcon,
            path: "/musteri/siparislerim",
            selectedPath: "/musteri/siparislerim",
            onClick: () => {
                history.push("/musteri/siparislerim");
                setIsMobileMenuOpen(false);
            }
        }
    ];
};

export const getMainMenuItems = (stores, history, setIsMobileMenuOpen) => {
    const isDedicatedIntegration = isDedicatedIntegrationCustomer(stores?.meStore);

    return [
        {
            title: "Anasayfa",
            icon: homeOutlinedIcon,
            path: "/musteri",
            onClick: () => {
                history.push("/musteri");
                setIsMobileMenuOpen(false);
            }
        },
        ...(isDedicatedIntegration
            ? [
                  {
                      title: "Vardiyalar",
                      icon: courierIcon,
                      path: "/musteri/vardiyalar",
                      onClick: () => {
                          history.push("/musteri/vardiyalar");
                          setIsMobileMenuOpen(false);
                      }
                  }
              ]
            : []),
        {
            title: "Siparişlerim",
            icon: deliveryIcon,
            path: "/musteri/siparislerim",
            onClick: () => {
                history.push("/musteri/siparislerim");
                setIsMobileMenuOpen(false);
            }
        },
        {
            title: "Muhasebe",
            icon: accountingIcon,
            path: "/musteri/muhasebe",
            onClick: () => {
                history.push("/musteri/muhasebe");
                setIsMobileMenuOpen(false);
            }
        },
        {
            title: i18n.t("screens.generalReports", {ns: "common"}),
            icon: accountingIcon,
            path: "/musteri/raporlar",
            selectedPath: "/musteri/raporlar",
            onClick: () => {
                history.push("/musteri/raporlar");
                setIsMobileMenuOpen(false);
            }
        },
        ...(IS_TICKET_EXTERNAL_ACCESS_BLOCKED
            ? []
            : [
                  {
                      title: i18n.t("menu.ticketManagement", {ns: "tickets"}),
                      icon: accountingIcon,
                      path: "/musteri/talep-yonetimi",
                      selectedPath: "/musteri/talep-yonetimi",
                      onClick: () => {
                          history.push("/musteri/talep-yonetimi");
                          setIsMobileMenuOpen(false);
                      }
                  }
              ]),
        {
            title: "Yeni Teslimat",
            icon: createDeliveryIcon,
            path: "/musteri/manuel-gonderi-olustur",
            onClick: () => {
                history.push("/musteri/manuel-gonderi-olustur");
                setIsMobileMenuOpen(false);
            }
        }
    ];
};
